import React,{useState,useEffect} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Panel from '../ui/Panel'
import PlayerCard from '../ui/PlayerCard'
import Avatar from '../ui/Avatar'
import './dashboard.css'

export default function PopularPlayers() {
    const [data,setData]=useState([])
    const [isLoading,setIsLoading]=useState(true)

    useEffect(()=>{
        loadData()
    },[])

    const loadData=()=>{
        //setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'manager/dashboard/popularplayers/'+sessionStorage.getItem('SportID')+'/'+sessionStorage.getItem('userToken'),{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
              }
          })
        .then(res=>{
            setData(res.data.slice(0, 10))
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)

        })
      }

      const dataList=data.map((item,index)=>{
        return(
            <Link className="player" to={`/user/${item.UUID}`} key={item.UUID || index}>
                <div className="rank num">{String(index+1).padStart(2,'0')}</div>
                <PlayerCard
                    uuid={item.UUID}
                    name={item.Name}
                    position={item.Position}
                    points={item.v}
                >
                    {/* 34px matches the avatar column in .player — the grid is untouched */}
                    <Avatar uuid={item.UUID} name={item.Name} size={34} />
                </PlayerCard>
                <div className="p-who">
                    <div className="p-name">{item.Name}</div>
                    <div className="p-pos">{item.Position ? item.Position : 'Position not set'}</div>
                </div>
                <div className="p-points">
                    <b className="num">{item.v}</b>
                    <span className="mono">pts</span>
                </div>
            </Link>
        )
      })

  return (
    <Panel
      title="Popular Players"
      subtitle={!isLoading && data.length>0 ? `Top ${data.length} by points earned` : 'By points earned'}
    >
      {isLoading &&
        <div className="sk-list">
          <div className="skeleton sk-line"></div>
          <div className="skeleton sk-line"></div>
          <div className="skeleton sk-line short"></div>
        </div>
      }

      {!isLoading && data.length===0 &&
        <div className="empty">No player activity yet.</div>
      }

      {!isLoading && data.length>0 &&
        <div className="players scroll-body h-match">
            {dataList}
        </div>
      }
    </Panel>
  )
}
